import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top whenever the path changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // This component does not render any UI
};

export default ScrollToTop;
